import { getFileType, getFileExtension } from "../fileUtils";
import { ResourceData } from "./types";
import {DEF_FILE_UPLOAD_SIZE} from 'core/constants/constant';

export const ALLOWED_EXT = [
  "png",
  "jpg",
  "jpeg",
  "tiff",
  "heic",
  "xlsx",
  "csv",
  "mp3",
  "mpeg",
  "wav",
  "docx",
  "doc",
  "pdf",
  "HEIC",
  "zip",
  "mov",
];

export const createResource = (sizeAllowed: number= DEF_FILE_UPLOAD_SIZE, file: File) => new Promise<ResourceData>((resolve, reject) => {
  const fileSize = file?.size || 0;
  const extension = getFileExtension(file?.name);

  if (!file || !fileSize) {
    return reject('Please select a file to upload');
  }
  if (!ALLOWED_EXT.includes(extension)) {
    return reject('Not approved extension to upload');
  }
  if (fileSize > sizeAllowed * 1024 * 1024) {
    return reject(`Please try file size below ${sizeAllowed}MB`);
  }

  const fileReader = new FileReader();

  if (!fileReader) {
    return reject('File Reader not supported');
  }

  fileReader.readAsArrayBuffer(file);

  fileReader.onload = async function (evt) {
    if (!evt?.target?.result) {
      return reject('Cannot load file');
    }

    const buffArr = new Uint8Array(evt?.target?.result as ArrayBuffer);
    const fileByteArray = [];

    for (let ii = 0; ii < buffArr.length; ii += 1) {
      fileByteArray.push(buffArr[ii]);
    }

    resolve({
      file: fileByteArray,
      type: getFileType(extension),
      extension,
      source:"LICENSE",
    });
  };
});
